Ext.define('SA.EditValidator', {
    statics: {
        forModel(model) {
            return new SA.EditValidator(model);
        }
    },

    constructor(model) {
        this.model = model;
        this.rules = [];
    },

    addRule(rule) {
        this.rules.push(rule);
    },

    addRuleType(ruleType) {
        this.addRule(Reflect.construct(ruleType, [this.model]));
    },

    getFirstMessage() {
        return this.rules.find(rule => rule.isBroken())?.getMessage();
    },

    requireAttribute() {
        return this.addRule(SA.EditRules.requireAttribute(this.model));
    },

    requireBusiness() {
        return this.addRule(SA.EditRules.requireBusiness(this.model));
    },

    requireLocation() {
        return this.addRule(SA.EditRules.requireLocation(this.model));
    }
});